import { render } from "./calculateCarriage.vue?vue&type=template&id=712ea3fe&scoped=true"
import script from "./calculateCarriage.vue?vue&type=script&lang=js"
export * from "./calculateCarriage.vue?vue&type=script&lang=js"

import "./calculateCarriage.vue?vue&type=style&index=0&id=712ea3fe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712ea3fe"]])

export default __exports__